import type { SwitchTradeCommandData } from '@festina/unitlink-general-types/unitlink'
import { typeUtils } from '@festina-life/core'
import {
  FormikCheckbox,
  FormikFieldArray,
  FormikSelect,
} from '@festina-life/ui/formikForms'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'
import type { FormikProps } from 'formik'

import { useEnumOptions } from '../../../hooks/useEnumOptions'
import { FundSelectionForm } from './FundSelectionForm'
import { SubPortfolioKeyInputs } from './SubPortfolioKeyInputs'

const validateKey = typeUtils.createValidator<SwitchTradeCommandData>()

export const SwitchTradeFormFields = ({
  values,
}: FormikProps<SwitchTradeCommandData>) => {
  const translate = useTranslate()
  const profileTypeOptions = useEnumOptions('ProfileType', 'unitlink')
  const translateEnum = useTranslateEnum()

  return (
    <>
      <SubPortfolioKeyInputs />
      <FormikCheckbox
        name={validateKey('rebalance')}
        label={translate('switchTradeModalButton.rebalance')}
      />
      <FormikCheckbox
        name={validateKey('updateProfile')}
        label={translate('switchTradeModalButton.updateProfile')}
      />
      <FormikSelect
        name={validateKey('profileType')}
        options={profileTypeOptions}
        label={translate('switchTradeModalButton.profileType')}
        renderFn={(option) =>
          translateEnum('unitLink.enum.ProfileType', option)
        }
        isRequired
      />
      {values.profileType === 'individualProfile' && (
        <FormikFieldArray
          name={validateKey('fundSelections')}
          label={translate('switchTradeModalButton.fundSelections')}
          elementLabel={translate('switchTradeModalButton.fundSelection')}
          elementInitializer={() => ({ _type: 'FundSelection' })}
          ChildElement={FundSelectionForm}
        />
      )}
    </>
  )
}
